<template>
    <div>
        <my-form class="form-page" v-model="form" table label-width="180px" @cancle="cancleHandler">
            <el-form-item label="招标项目" class="table-full-row" v-if="type!='1'">
                {{model.zbprocode}}--{{model.zbproname}}
            </el-form-item>
            <el-form-item label="标段名称">
                {{form.bdname}}
            </el-form-item>
            <el-form-item label="标段编码">
                {{form.bdcode}}
            </el-form-item>
            <el-form-item label="公示名称">
                {{form.gsname}}
            </el-form-item>
            <el-form-item label="公示类型">
                {{form.gstypename}}
            </el-form-item>
            <el-form-item label="项目经理">
                {{form.e_xmjl}}
            </el-form-item>
            <el-form-item label="身份证号">
                {{form.e_sfzh}}
            </el-form-item>
            <el-form-item label="经理资质">
                {{form.e_jlzz}}
            </el-form-item>
            <el-form-item label="开标时间">
                {{form.e_kbsj}}
            </el-form-item>
            <el-form-item label="公示开始时间">
                {{form.gsstarttime}}
            </el-form-item>
            <el-form-item label="公示结束时间">
                {{form.gsendtime}}
            </el-form-item>
            <el-form-item label="全部投标单位">
                {{form.qbtbdw}}
            </el-form-item>
            <el-form-item label="否决单位及理由">
                {{form.fjdwjly}}
            </el-form-item>

            <el-form-item label="招标限价（万元）" v-if="model.jt">
                {{form.zbxj}}
            </el-form-item>
            <el-form-item label="公示内容文本" class="table-full-row tableStyle">
                <span v-html="form.gscontent"></span>
            </el-form-item>
            <el-form-item label="异议渠道或方式" class="table-full-row">
                <span class="cmm-wrapper" v-html="form.ext_complaints"></span>
            </el-form-item>
            <el-form-item label="附件" class="table-full-row">
                <my-upload
                ref="myUpload"
                readonly
                :file-guid="form.fileguid">
                </my-upload>
            </el-form-item>
            

            <template slot="btn" slot-scope="scope">
                <el-button icon="el-icon-circle-close" @click="scope.cancleHandler">取消</el-button>
            </template>
        </my-form>

    </div>
</template>

<script>
import FORM_PAGE_MIXIN from '@views/mixins/form-page'


export default {
    mixins: [FORM_PAGE_MIXIN],

    data: () => ({
        form: {},
        model:{},
        type:'',//判断是否候选人公示审核进来  type=1 是
    }),
    methods: {
        
        
    },
    created() {
        this.type = this.getQuery('type')
        // 判断是否候选人公示审核进来  type=1 是
        if(this.type=='1'){
            this.jspInit(`${this.getGetters('mngUrl')}/manage/business/auditzbhxrgs/detail.json`,{
                id:this.getQuery('id'),
            }, data => {
                this.form = data.model
            });
            
        }else{
            this.jspInit(`${this.getGetters('mngUrl')}/DingBiao/ZbHxrGs/detail.json`,{
                procode:this.getQuery('procode'),
                id:this.getQuery('id'),
                isXt:this.getQuery('isXt'),
            }, data => {
                this.model = data
                this.form = data.model
            });
        }
        
    },
    mounted() {
 
    },
}
</script>

<style>
.cmm-wrapper{
    white-space: pre-wrap;
}
.tableStyle .el-form-item__content table{ table-layout: fixed; }
.tableStyle .el-form-item__content table td{ word-break: break-all;}
</style>
